<template>
  <div
    @click="updateSelectedPlayer"
    class="border-1 justify-right box-border flex h-[8vh] min-h-[4rem] w-[48%] flex-wrap items-center rounded-xl border-2 p-2 text-2xl text-white transition-colors hover:cursor-pointer hover:bg-saudi-purple md:h-[15vh]"
    :class="[
      player.id === matchingPlayerId
        ? 'border-saudi-purple/50 border-2'
        : ' border-saudi-dark',
      locale === 'ar' ? 'flex-row-reverse' : 'flex-row',
    ]"
  >
    <div class="flex h-full w-[30%] flex-row items-center justify-center">
      <div
        class="relative box-border flex h-[9vmin] w-[9vmin] items-center justify-center overflow-hidden rounded-full border-[1px] border-white md:border-2"
      >
        <img
          class="h-full w-full object-fill"
          src="../assets/spottyBackground.png"
          alt="Background Image"
        />
        <img
          class="absolute h-full w-full rounded-full object-fill"
          :src="player?.image"
          alt="Player Image"
        />
      </div>
    </div>
    <div
      :class="locale === 'ar' ? 'mr-[2.5%]' : 'ml-[2.5%]'"
      class="h-full text-center text-sm md:text-[2vw]"
    >
      <div
        :class="
          locale === 'ar'
            ? 'flex-row-reverse  justify-start'
            : 'flex-row justify-start'
        "
        class="flex h-[30%] flex-wrap items-center gap-[0.2vw] text-[2vw] font-bold md:h-[40%] md:text-[1.1vw]"
      >
        <div
          :class="locale === 'ar' ? 'justify-end' : 'justify-start'"
          class="flex"
        >
          {{ capitaliseName(player.Given_name) }}
        </div>
        <div
          :class="locale === 'ar' ? 'justify-end' : 'justify-start'"
          class="flex"
        >
          {{ capitaliseName(player.Family_name) }}
        </div>
      </div>

      <div
        :class="
          locale === 'ar'
            ? 'md:text-[0.8vw] text-right text-[1.4vw]'
            : 'md:text-[1.2vw] text-left text-[2vw]'
        "
        class="flex h-[60%] flex-col text-slate-300 md:h-[40%] md:gap-1"
      >
        <div class="justify-right h-[50%] w-full items-start">
          {{ player.Position }}
        </div>
        <div class="justify-right h-[30%] w-full items-start">
          {{
            locale === "ar"
              ? `${player.Caps} :${$t("caps")} `
              : `${$t("caps")}: ${player.Caps}`
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  matchingPlayerId: Number,
  player: Object,
  locale: String,
});

const emit = defineEmits(["updateSelectedPlayer"]);

const updateSelectedPlayer = () => {
  emit("updateSelectedPlayer", props.player);
};

function capitaliseName(name) {
  return name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
</script>
